import { render, staticRenderFns } from "./PortalSelect.vue?vue&type=template&id=3b335783&scoped=true&"
import script from "./PortalSelect.vue?vue&type=script&lang=js&"
export * from "./PortalSelect.vue?vue&type=script&lang=js&"
import style0 from "./PortalSelect.vue?vue&type=style&index=0&id=3b335783&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b335783",
  null
  
)

export default component.exports